import { StandardEvents } from '@shopify/events';

// Use the same server-rendered variant response as Savor's price and cart button.
class FittsPurchaseAssurance extends HTMLElement {
  #section;
  #generation = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#generation++;
  }

  #onProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    const generation = ++this.#generation;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.#generation || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = Array.from(detail.html.querySelectorAll('fitts-purchase-assurance'))
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      const content = replacement?.querySelector('[data-assurance-content]');
      const current = this.querySelector('[data-assurance-content]');
      if (!content || !current) return;
      current.replaceWith(content.cloneNode(true));
      this.dataset.productId = replacement.dataset.productId;
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[fitts-purchase-assurance] Variant update failed:', error);
    }
  };
}

if (!customElements.get('fitts-purchase-assurance')) {
  customElements.define('fitts-purchase-assurance', FittsPurchaseAssurance);
}
